import { Divider } from "antd";
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  selectDiscoverySetting,
  selectDiscoveryId,
  selectDiscoveryGroup
} from "../../store/reducers";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import GroupVisualizations from "../../utils/group-visualizations";
import { useMobileMediaQuery } from "../Responsive";
import { updateDiscoverySettingsGroup } from "../../store/actions/discoveries";
import ExpandedOrCollapsed from "../../utils/ExpandedOrCollapsed";
import { isDiscoveryGroupCollapsed } from "../../store/selectors/discovery";
import { GroupCollapse, Text } from "../../components";

const Group = ({
  discoveryId,
  groupCode,
  discoveryGroup,
  collapsed,
  collapsible,
  children,
  updateDiscoverySettingsGroup,
  showGroupDescription
}) => {
  const isMobile = useMobileMediaQuery();

  const renderContents = () => {
    return (
      <>
        {discoveryGroup.definition.description && showGroupDescription ? (
          <GroupDescription>
            {discoveryGroup.definition.visualizationOption ===
            GroupVisualizations.SUBTOTAL_GROUP ? (
              <Text variant={isMobile ? "bodyMobile" : "small"}>
                {discoveryGroup.definition.description}
              </Text>
            ) : (
              <Text color={"gray4"}>
                {discoveryGroup.definition.description}
              </Text>
            )}
          </GroupDescription>
        ) : null}
        <List>{children}</List>
        {collapsible ? <Divider /> : null}
      </>
    );
  };

  const toggleState = () => {
    updateDiscoverySettingsGroup({
      discoveryId,
      groupId: groupCode,
      status: !collapsed
        ? ExpandedOrCollapsed.COLLAPSED
        : ExpandedOrCollapsed.EXPANDED
    });
  };

  return (
    <Container order={discoveryGroup.definition.order} data-cy={"group"}>
      <GroupCollapse
        title={discoveryGroup.definition.name}
        onCollapse={toggleState}
        collapsed={collapsed}
        collapsible={collapsible}
      >
        {renderContents()}
      </GroupCollapse>
    </Container>
  );
};

Group.propTypes = {
  groupCode: PropTypes.string.isRequired,
  collapsed: PropTypes.bool,
  showGroupDescription: PropTypes.bool,
  children: PropTypes.node,
  initiallyCollapsed: PropTypes.oneOf([undefined, true, false]),
  collapsible: PropTypes.bool
};

Group.defaultProps = {
  collapsed: false,
  initiallyCollapsed: undefined,
  showGroupDescription: true,
  collapsible: true
};

const Container = styled.div`
  order: ${(props) => props.order};
`;

const GroupDescription = styled.div`
  margin-bottom: 20px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const mapStateToProps = (state, props) => {
  const isGroupCollapsed = isDiscoveryGroupCollapsed(
    selectDiscoverySetting(state, "groups"),
    props.groupCode
  );

  const initiallyCollapsed = props.hasOwnProperty("initiallyCollapsed")
    ? props.initiallyCollapsed
    : true;

  const collapsed =
    isGroupCollapsed !== undefined ? isGroupCollapsed : initiallyCollapsed;

  return {
    discoveryId: selectDiscoveryId(state),
    discoveryGroup: selectDiscoveryGroup(state, props.groupCode),
    collapsed
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDiscoverySettingsGroup
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(Group);
